export const msgMenus = [
  { name: "互动消息", value: "interact" },
  { name: "私信", value: "private" },
  { name: "系统通知", value: "system" },
];
